export enum ShippingPriceType {
  KIT = 'KIT',
  OTHERS = 'OTHERS',
}
